import { request } from '.';
import { jwtDecode } from "jwt-decode";

const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT;

export const getAccessToken = async () => {

  return localStorage.getItem("accessToken");
};

export const getDecodedTokenValue = async () => {
  try {
    const token = await getAccessToken();
    return jwtDecode(token)
  } catch (e) {
    return null
  }
}

export const getRefreshToken = () => {
  return localStorage.getItem("refreshToken");
};

// Guest login has been REMOVED — guest sessions are no longer supported.

const requestLoginOtp = (body) => {
  return request({
    method: 'post',
    url: `${API_ENDPOINT}/user/requestLoginOTP`,
    data: body,
  });
};

const otpLogin = (body) => {
  return request({
    method: 'post',
    url: `${API_ENDPOINT}/user/loginWithOTP`,
    data: body,
  });
};
const refreshAccessToken = (body) => {
  return request({
    method: 'post',
    url: `${API_ENDPOINT}/user/oauth/token`,
    data: body,
  });
};


export { requestLoginOtp, otpLogin, refreshAccessToken };
